<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="contact"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
            
            <base-collapsible-form 
              ref="baseCollapsibleGeneral"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('app.general_information')}}</h4>
              </template>
              <template slot="content">

               <div class="flex flex-col lg:flex-row gap-x-6">

                <div class="w-full" 
                    v-if="(role === 7 || role === 8 || role === 3 || role === 9)">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
                    <div class="flex justify-between">
                      <el-form-item prop="IdCliente" class="w-full">       
                        <el-select class="w-full" 
                          v-model="form.IdCliente" 
                          clearable 
                          filterable 
                          :placeholder="$t('app.select')"
                          :loading="loadingClientes" 
                          :disabled="true">
                          <el-option
                            v-for="opt in clientes"
                            :key="opt.key"
                            :label="opt.label"
                            :value="opt.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <base-button v-if="form.IdCliente" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                    </div>
                  </div>
                </div>

              </template>
            </base-collapsible-form>
            
            <base-collapsible-form 
              ref="baseCollapsibleTaxIdentification"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.tax_identification')}}</h4>
              </template>
              <template slot="content">

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.PersonTypeCode')}}</label>
                  <el-form-item prop="PersonType">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.PersonType" 
                      :disabled="true"
                      :active-text="$t('tipos.persona.juridica')"
                      :inactive-text="$t('tipos.persona.fisica')"
                      inactive-color="var(--primary-800)"/>
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.ResidenceTypeCode')}}</label>
                  <el-form-item prop="ResidenceType">

                    <el-select class="w-full" 
                      v-model="form.ResidenceType"
                      :disabled="true">
                        <el-option
                          v-for="opt in tiposResidencia"
                          :key="opt.id"
                          :label="opt.name"
                          :value="opt.id">
                      </el-option>
                    </el-select>

                  </el-form-item>
                </div>
                
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.TaxIdentificationNumber')}}</label>
                  <el-form-item prop="TIN">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.TIN"
                      :disabled="true"
                      minlength="3"
                      maxlength='30'
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('tipos.pge.autofactura') }}</label>
                  <el-form-item prop="IsSeflInvoiceSociety">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.IsSeflInvoiceSociety" 
                      :disabled="true"
                      :active-text="$t('app.yes')"
                      :inactive-text="$t('app.no')"
                    />
                  </el-form-item>
                </div>

                <div v-if="form.IsSeflInvoiceSociety" >
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.self_invoice_email') }}</label>
                  <el-form-item prop="SendEmailSelfInvoice">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.SendEmailSelfInvoice" 
                      :disabled="true"
                      :active-text="$t('app.yes')"
                      :inactive-text="$t('app.no')"
                    />
                  </el-form-item>
                </div>

              </template>
            </base-collapsible-form>
            
            <base-collapsible-form 
              ref="baseCollapsibleEntity"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.entity')}}</h4>
              </template>
              <template slot="content">
                
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>
                    {{ form.PersonType? $t('companies.companyName') : $t('app.name') }}
                  </label>
                  <el-form-item prop="NameCorporateName">
                    <el-input
                      clearable
                      :disabled="true"
                      class="w-full"
                      v-model="form.NameCorporateName"
                      maxlength='80'
                    />
                  </el-form-item>
                </div>
                
                <div v-if="!form.PersonType">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>
                    {{ $t('persons_data.firstsurname') }}
                  </label>
                  <el-form-item prop="FirstSurname">
                    <el-input
                      clearable
                      :disabled="true"
                      class="w-full"
                      v-model="form.FirstSurname"
                      maxlength='40'
                    />
                  </el-form-item>
                </div>
                
                <div v-if="!form.PersonType">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    {{ $t('persons_data.secondsurname') }}
                  </label>
                  <el-form-item prop="SecondSurname">
                    <el-input
                      clearable
                      :disabled="true"
                      class="w-full"
                      v-model="form.SecondSurname"
                      maxlength='40'
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
            
            <base-collapsible-form 
              v-if="form.PersonType"
              ref="baseCollapsibleRegistrationData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.RegistrationData')}}</h4>
              </template>
              <template slot="content">
                
                <div class="flex flex-col md:flex-row items-center gap-x-2">

                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Book') }}</label>
                    <el-form-item prop="Book">
                      <el-input
                        clearable
                        :disabled="true"
                        class="w-full"
                        v-model="form.Book"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                  
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.RegisterOfCompaniesLocation') }}</label>
                    <el-form-item prop="RegisterOfCompaniesLocation">
                      <el-input
                        clearable
                        :disabled="true"
                        class="w-full"
                        v-model="form.RegisterOfCompaniesLocation"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>

                </div>
                  
                <div class="flex flex-col md:flex-row items-center gap-x-2">

                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Sheet') }}</label>
                    <el-form-item prop="Sheet">
                      <el-input
                        clearable
                        :disabled="true"
                        class="w-full"
                        v-model="form.Sheet"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Folio') }}</label>
                    <el-form-item prop="Folio">
                      <el-input
                        clearable
                        :disabled="true"
                        class="w-full"
                        v-model="form.Folio"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                </div>
                
                <div class="flex flex-col md:flex-row items-center gap-x-2">

                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Section') }}</label>
                    <el-form-item prop="Section">
                      <el-input
                        clearable
                        :disabled="true"
                        class="w-full"
                        v-model="form.Section"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>
                
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Volume') }}</label>
                    <el-form-item prop="Volume">
                      <el-input
                        clearable
                        :disabled="true"
                        class="w-full"
                        v-model="form.Volume"
                        maxlength='20'
                      />
                    </el-form-item>
                  </div>

                </div>
                
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.additional_data') }}</label>
                  <el-form-item prop="AdditionalData">
                    <el-input
                      clearable
                      :disabled="true"
                      class="w-full"
                      v-model="form.AdditionalData"
                      maxlength='20'
                    />
                  </el-form-item>
                </div>

                </template>
              </base-collapsible-form>
                
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="check"
            @click="deleteSociedad()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="check"
            @click="restoreSociedad()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <Dialog
        :title="$t('contacto.delete_contact')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'

import DetailLayout from '@/components/layout/DetailLayout.vue'

import { getClients } from '@/services/clients/getClients'
import { getSociedad } from '@/services/configurations/getSociedad'
import { deleteTrashSociedad } from '@/services/trash/deleteTrashSociedad'
import { restoreTrashSociedad } from '@/services/trash/restoreTrashSociedad'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-contacto',
  components: {
    DetailLayout,
    Dialog,
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      distribuidores: [],
      loadingClientes: false,
      header: {
        title: i18n.t('agenda.delete_sociedad_detail'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'trash/society'
      },
      form: this.getDefaultForm(),
      clientes: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation_f', { entity: i18n.t('agenda.sociedad').toLowerCase() }),
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    hasAutofactura: function () {
      return !!this.$store.getters['auth/hasAutofacturaModule']
    },
    tiposRolAgenda: function () {
      return this.$store.getters['config/TIPOS_ROL_AGENDA']
    },
    tiposResidencia: function () {
      return this.$store.getters['config/TIPOS_RESIDENCIA']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
  },
  created: async function () {
    const breadcrumbs = []

    breadcrumbs.push({ path: 'trash/society', name: i18n.t('trash.header') })
    breadcrumbs.push({ path: 'trash/society', name: i18n.t('agenda.deleted_sociedades') })
    const sociedad = await this.downloadData(this.id)
    const cabecera = sociedad.respuesta?.NameCorporateName || '' 
    breadcrumbs.push({ path: '', name: cabecera })
    this.$store.commit('app/setheaderBreadCrumb', cabecera)
      
    this.header.breadcrumb = breadcrumbs



    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: x.idCliente }))
      this.loadingClientes = false
    } else {
      this.form.idCliente = this.getIdClientLogged
    }
  },
  mounted () {
    this.$refs.baseCollapsibleGeneral.toggle()
    this.$refs.baseCollapsibleTaxIdentification.toggle()
    this.$refs.baseCollapsibleEntity.toggle()
  },
  methods: {
    getDefaultForm: function () {
      return {
        IdCliente: null,
        Cliente: '',
        AgendaGeneral: null,
        TIN: '',
        ResidenceType: 'R',
        PersonType: 'F',
        NameCorporateName: '',
        FirstSurname: '',
        SecondSurname: '',
        Book: '',
        RegisterOfCompaniesLocation: '',
        Sheet: '',
        Folio: '',
        Section: '',
        Volume: '',
        AdditionalData: '',
        SendEmailSelfInvoice: false,
        IsSeflInvoiceSociety: false,
      }
    },
    goDetailClient () {
      const id = this.form.IdCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'trash/society' })
    },
    downloadData: async function (id) {
      let sociedad = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          borrado: true,
          IdSociedad: id
        }
        sociedad = await getSociedad(params)
        this.setSociedad(sociedad.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return sociedad
    },
    deleteSociedad () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          IdSociedades: []
        }
        payload.IdSociedades.push(this.id)
        const response = await deleteTrashSociedad(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreSociedad: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          IdSociedades: []
        }
        payload.IdSociedades.push(this.id)
        const response = await restoreTrashSociedad(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    setSociedad: function (sociedad) {
      this.form.IdCliente = sociedad.IdCliente
      this.form.IsSeflInvoiceSociety = sociedad.IsSeflInvoiceSociety
      this.form.TIN = sociedad.TIN
      this.form.ResidenceType = sociedad.ResidenceType
      this.form.PersonType = sociedad.PersonType === 'J'
      this.form.NameCorporateName = sociedad.NameCorporateName
      this.form.FirstSurname = sociedad.FirstSurname
      this.form.SecondSurname = sociedad.SecondSurname
      this.form.Book = sociedad.RegistrationData?.Book
      this.form.RegisterOfCompaniesLocation = sociedad.RegistrationData?.RegisterOfCompaniesLocation
      this.form.Sheet = sociedad.RegistrationData?.Sheet
      this.form.Folio = sociedad.RegistrationData?.Folio
      this.form.Section = sociedad.RegistrationData?.Section
      this.form.Volume = sociedad.RegistrationData?.Volume
      this.form.AdditionalData = sociedad.RegistrationData?.AdditionalData
      this.form.SendEmailSelfInvoice = sociedad.SendEmailSelfInvoice
    },
    updateView: function () {
      const cabecera = this.form.Name + ' ' + (this.form.FirstSurname || '')
      this.header.breadcrumb[2].name = cabecera
      this.$store.commit('app/setheaderBreadCrumb', cabecera)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
